<!-- success-message.component.html -->
<div class="message-overlay">
    <div class="message-box">
      <div class="message-content">
        <div class="success-icon">✓</div>
        <h3>Success!</h3>
        <p>{{ message }}</p>
      </div>
      <div class="message-actions">
        <button class="close-btn" (click)="closeMessage()">Close</button>
      </div>
    </div>
</div>